import React from "react";

import p2i01 from "../../static/images/details_p02_ic01.png";
import p2i02 from "../../static/images/details_p02_ic02.png";
import p2i03 from "../../static/images/details_p02_ic03.png";
import p2i04 from "../../static/images/details_p02_ic04.png";
import p2i05 from "../../static/images/details_p02_ic05.png";
import p2i06 from "../../static/images/details_p02_ic06.png";
import p2i07 from "../../static/images/details_p02_ic07.png";
import p2i08 from "../../static/images/details_p02_ic08.png";
import p2i09 from "../../static/images/details_p02_ic09.png";
import p2i10 from "../../static/images/details_p02_ic10.png";
import p2i11 from "../../static/images/details_p02_ic11.png";
import p2i12 from "../../static/images/details_p02_ic12.png";

import p3i01 from "../../static/images/details_p03_ic01.png";
import p3i02 from "../../static/images/details_p03_ic02.png";
import p3i03 from "../../static/images/details_p03_ic03.png";
import p3i04 from "../../static/images/details_p03_ic04.png";
import p3i05 from "../../static/images/details_p03_ic05.png";
import p3i06 from "../../static/images/details_p03_ic06.png";
import p3i07 from "../../static/images/details_p03_ic07.png";

import p4i01 from "../../static/images/details_p04_ic01.png";
import p4i02 from "../../static/images/details_p04_ic02.png";
import p4i03 from "../../static/images/details_p04_ic03.png";

import p5i01 from "../../static/images/details_p05_ic01.png";
import p5i02 from "../../static/images/details_p05_ic02.png";
import p5i03 from "../../static/images/details_p05_ic03.png";
import p5i04 from "../../static/images/details_p05_ic04.png";

import p6i01 from "../../static/images/details_p06_ic01.png";
import p6i02 from "../../static/images/details_p06_ic02.png";

const IconMap = {
  p2i01,
  p2i02,
  p2i03,
  p2i04,
  p2i05,
  p2i06,
  p2i07,
  p2i08,
  p2i09,
  p2i10,
  p2i11,
  p2i12,
  p3i01,
  p3i02,
  p3i03,
  p3i04,
  p3i05,
  p3i06,
  p3i07,
  p4i01,
  p4i02,
  p4i03,
  p5i01,
  p5i02,
  p5i03,
  p5i04,
  p6i01,
  p6i02
};

const FeatureIcon = props => {
  const { type, name, price } = props;
  return (
    <span className="detail-feature-icon">
      <img src={IconMap[type]} alt="icon" />
      {name ? <span className="icon-name">{name}</span> : null}
      {price ? <i className="tag icon-price">{price}</i> : null}
    </span>
  );
};

export default FeatureIcon;
